const HTF_STEP_UP_CATEGORIES = [
    {
        name: "Context Candle",
        items: [
            {
                id: "macro_pq_group",
                label: "Price Quality",
                children: [
                    {
                        id: "macro_vol_amp_group",
                        label: "Volatility",
                        children: [
                            { id: "macro_vol_expansion", label: "Expansion" },
                            { id: "macro_vol_compression", label: "Compression" },
                            { id: "macro_vol_normal", label: "Normal" }
                        ]
                    }
                ]
            },
            {
                id: "macro_candle_types_group",
                label: "Candlestick Pattern",
                children: [
                    { id: "macro_type_marubozu", label: "Marubozu" },
                    { id: "macro_type_momentum", label: "Momentum" },
                    { id: "macro_type_engulfing", label: "Engulfing" },
                    { id: "macro_type_doji", label: "Doji" },
                    { id: "macro_type_inside_bar", label: "Inside Bar" }
                ]
            }
        ]
    },
    {
        name: "Bias Candle(s)",
        items: [
            {
                id: "bias_pq_group",
                label: "Price Quality",
                children: [
                    {
                        id: "bias_vol_amp_group",
                        label: "Volatility",
                        children: [
                            { id: "bias_vol_expansion", label: "Expansion" },
                            { id: "bias_vol_compression", label: "Compression" },
                            { id: "bias_vol_normal", label: "Normal" }
                        ]
                    }
                ]
            },
            {
                id: "bias_candle_types_group",
                label: "Candlestick Pattern",
                children: [
                    { id: "bias_type_marubozu", label: "Marubozu" },
                    { id: "bias_type_momentum", label: "Momentum" },
                    { id: "bias_type_engulfing", label: "Engulfing" },
                    { id: "bias_type_doji", label: "Doji" },
                    { id: "bias_type_inside_bar", label: "Inside Bar" },
                    { id: "bias_type_tweezers", label: "Tweezers" },
                    { id: "bias_type_multiple_wicks", label: "Multiple Wicks" }
                ]
            }
        ]
    }
];

const BIAS_TF_ANALYSIS_CATEGORIES = [
    {
        name: "Cycle",
        items: [
            { id: "bias_cycle_expansion", label: "Expansion" },
            { id: "bias_cycle_consolidation", label: "Consolidation" }
        ]
    },
    {
        name: "Structure",
        items: [
            { id: "bias_trend_uptrend", label: "Uptrend" },
            { id: "bias_trend_downtrend", label: "Downtrend" },
            { id: "bias_struct_range", label: "Range" }
        ]
    },
    {
        name: "Price Quality",
        items: [
            {
                id: "bias_pq_trend_group",
                label: "Trend",
                children: [
                    { id: "bias_pq_trend_strong", label: "Strong" },
                    { id: "bias_pq_trend_weak", label: "Weak" }
                ]
            },
            {
                id: "bias_pq_mom_group",
                label: "Momentum",
                children: [
                    { id: "bias_pq_mom_strong", label: "Strong" },
                    { id: "bias_pq_mom_weak", label: "Weak" }
                ]
            }
        ]
    }
];

const OBSERVATION_ZONE_CATEGORIES = [
    {
        name: "Minor Structure",
        items: [
            { id: "obs_scenario_continuation", label: "Pullback" },
            { id: "obs_scenario_flip", label: "Flip Zone" },
            { id: "obs_scenario_breakout", label: "Range Expansion" }
        ]
    },
    {
        name: "Retracement",
        items: [
            { id: "ret_less_05", label: "≤ 50%" },
            { id: "ret_greater_05", label: "≥ 50%" },
            { id: "ret_62_79", label: "62–79%" }
        ]
    },
    {
        name: "Liquidity Event",
        items: [
            {
                id: "obs_liq_val_group",
                label: "Validation",
                children: [
                    { id: "obs_liq_valid", label: "Valid" },
                    { id: "obs_liq_invalid", label: "Opposite Liquidity Event" }
                ]
            },
            {
                id: "obs_liq_pq_group",
                label: "Price Quality",
                children: [
                    { id: "obs_liq_decisive", label: "Decisive Reaction" },
                    { id: "obs_liq_rejection_wick", label: "Rejection Wick (≥ 60% / > 1 ATR)" }
                ]
            },
            {
                id: "obs_liq_cp_group",
                label: "Candlestick Pattern",
                children: [
                    { id: "obs_liq_pin_bars", label: "Pin Bars" },
                    { id: "obs_liq_multi_wicks", label: "Multiple Wicks" },
                    { id: "obs_liq_tweezers", label: "Tweezers" }
                ]
            }
        ]
    }
];

const SCENARIO_CATEGORIES = [
    {
        name: "Chart-Based",
        items: [
            {
                id: "lvl_structural_group",
                label: "Structural",
                children: [
                    { id: "lvl_swing_high", label: "Swing High" },
                    { id: "lvl_swing_low", label: "Swing Low" },
                    { id: "lvl_50_retracement", label: "50% Retracement" },
                    { id: "eqh", label: "Equal Highs (EQH)" },
                    { id: "eql", label: "Equal Lows (EQL)" },
                    { id: "mid_range", label: "Mid-Range (50%)" }
                ]
            },
            {
                id: "lvl_psychological_group",
                label: "Psychological",
                children: [
                    { id: "psy_major", label: "Major Round Numbers — 5000, 4000" },
                    { id: "psy_minor", label: "Minor Round Numbers — 5050, 4050" }
                ]
            },
            {
                id: "lvl_time_based_group",
                label: "Time-Based",
                children: [
                    {
                        id: "tf_yearly",
                        label: "Yearly",
                        children: [
                            { id: "yr_open", label: "Yearly Open" },
                            { id: "yearly_hl", label: "Yearly High / Low" }
                        ]
                    },
                    {
                        id: "tf_6month",
                        label: "6-Month",
                        children: [
                            { id: "m6_open", label: "6-Month Open" },
                            { id: "m6_hl", label: "6-Month High / Low" }
                        ]
                    },
                    {
                        id: "tf_3month",
                        label: "3-Month",
                        children: [
                            { id: "m3_open", label: "3-Month Open" },
                            { id: "m3_hl", label: "3-Month High / Low" }
                        ]
                    },
                    {
                        id: "tf_monthly",
                        label: "Monthly",
                        children: [
                            { id: "mn_open", label: "Monthly Open" },
                            { id: "monthly_hl", label: "Monthly High / Low" }
                        ]
                    },
                    {
                        id: "tf_weekly",
                        label: "Weekly",
                        children: [
                            { id: "wk_open", label: "Weekly Open" },
                            { id: "weekly_hl", label: "Weekly High / Low" }
                        ]
                    },
                    {
                        id: "tf_daily",
                        label: "Daily",
                        children: [
                            { id: "dy_open", label: "Daily Open" },
                            { id: "daily_hl", label: "Daily High / Low" }
                        ]
                    },
                    {
                        id: "tf_session",
                        label: "Session",
                        children: [
                            { id: "session_open", label: "Session Open" },
                            { id: "session_hl", label: "Session High / Low" }
                        ]
                    }
                ]
            },
            {
                id: "lvl_volume_based_group",
                label: "Volume-Based",
                children: [
                    { id: "vp_poc", label: "POC" }
                ]
            }
        ]
    },
    {
        name: "Contextual",
        items: [
            {
                id: "lvl_options_group",
                label: "Options-Based",
                children: [
                    { id: "gamma_flip", label: "Gamma Flip" },
                    { id: "call_wall", label: "Call Wall" },
                    { id: "put_wall", label: "Put Wall" },
                    { id: "high_oi", label: "High OI Strike" },
                    { id: "max_pain", label: "Max Pain" }
                ]
            },
            {
                id: "lvl_volatility_group",
                label: "Volatility-Based",
                children: [
                    { id: "exp_move_1d", label: "Expected Move Band (1D)" },
                    { id: "exp_move_5d", label: "Expected Move Band (5D)" }
                ]
            }
        ]
    },
    {
        name: "Supply / Demand",
        items: [
            { id: "sd_impulse_origin", label: "Impulse Origin" },
            { id: "sd_flipped_impulse_origin", label: "Flipped Impulse Origin" },
            { id: "sd_imbalance", label: "Imbalance" },
            { id: "sd_flipped_imbalance", label: "Flipped Imbalance" }
        ]
    },
    {
        name: "Moving Average",
        items: [
            { id: "lvl_sma_200", label: "SMA 200" },
            { id: "lvl_ema_50", label: "EMA 50" },
            { id: "lvl_ema_20", label: "EMA 20" }
        ]
    }
];

const CONFIRMATION_CATEGORIES = [
    {
        name: "Structure Shift",
        items: [
            { id: "conf_shift_choch", label: "Structural Shift (Minor Shift)" },
            { id: "conf_shift_break_retest", label: "Break & Retest" }
        ]
    },
    {
        name: "Chart Pattern",
        items: [
            { id: "conf_pattern_hs", label: "Head & Shoulders" },
            { id: "conf_pattern_double_top_bottom", label: "Double Top / Bottom" }
        ]
    }
];

const ENTRY_MODEL_CATEGORIES = [
    {
        name: "Trigger",
        items: [
            { id: "entry_trigger_full_body_close", label: "Full-Body Close" }
        ]
    },
    {
        name: "Candlestick Pattern",
        items: [
            { id: "entry_candle_marubozu", label: "Marubozu" },
            { id: "entry_candle_momentum", label: "Momentum" },
            { id: "entry_candle_engulfing", label: "Engulfing" }
        ]
    }
];

export const MARKET_STRUCTURE_DATA = {
    "htf_step_up": {
        label: "HTF Context",
        subtitle: "Context that encompasses the bias",
        description: "The market structure that encompasses bias or The higher-timeframe context in which the bias develops.",
        categories: HTF_STEP_UP_CATEGORIES
    },
    "bias_tf_analysis": {
        label: "BIAS",
        subtitle: "Cycle & Structure",
        description: "Market cycle, trend direction and price quality framework.",
        categories: BIAS_TF_ANALYSIS_CATEGORIES
    },
    "value_decision_zone": {
        label: "Observation Zone",
        subtitle: "Area of Interest",
        description: "Minor structure, retracement depth & liquidity event (stop run / rejection).",
        categories: OBSERVATION_ZONE_CATEGORIES
    },
    "scenario": {
        label: "Scenario",
        subtitle: "Key Levels",
        description: "Start, End, and Invalidation levels for trade execution.",
        categories: SCENARIO_CATEGORIES
    },

    "confirmation_signals": {
        label: "Confirmation",
        subtitle: "Reaction at Level",
        description: "LTF structural shift (Break & Retest) and chart patterns.",
        categories: CONFIRMATION_CATEGORIES
    },
    "entry_model": {
        label: "Entry Model",
        subtitle: "Execution Trigger",
        description: "Full-body close trigger and candlestick confirmation (Marubozu, Momentum, Engulfing).",
        categories: ENTRY_MODEL_CATEGORIES
    },
    "exit_reasons": {
        label: "Exit Reason",
        subtitle: "Trade Conclusion",
        description: "Why the trade was closed.",
        categories: [
            {
                name: "Invalidation",
                items: [
                    { id: "exit_inv_sl", label: "Stop Loss Hit" },
                    { id: "exit_inv_struct", label: "Structure Broken" }
                ]
            },
            {
                name: "Probability Loss",
                items: [
                    { id: "exit_prob_rej_strong", label: "Strong Rejection" },
                    { id: "exit_prob_rej_multi", label: "Multiple Rejections" },
                    { id: "exit_prob_failed_bo", label: "Failed Breakout" }
                ]
            },
            {
                name: "Target",
                items: [
                    { id: "exit_tgt_full", label: "Full Take Profit" },
                    { id: "exit_tgt_rej", label: "TP + Rejection" },
                    { id: "exit_tgt_partial", label: "Partial Take Profit" }
                ]
            },
            {
                name: "Management",
                items: [
                    { id: "exit_mgt_trail", label: "Trailing Stop Hit" },
                    { id: "exit_mgt_protect", label: "Protective Stop Hit" },
                    { id: "exit_mgt_be", label: "Breakeven Exit" }
                ]
            },
            {
                name: "Context",
                items: [
                    { id: "exit_ctx_eow", label: "End of Week" },
                    { id: "exit_ctx_news", label: "Pre-News" },
                    { id: "exit_ctx_shift", label: "Major News / Event Shift" }

                ]
            },
            {
                name: "Time",
                items: [
                    { id: "exit_time_long", label: "Trade Took Too Long" }
                ]
            },
            {
                name: "Errors",
                items: [
                    { id: "exit_err_exec", label: "Execution Mistake" }
                ]
            }
        ]
    }
};
